exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.subtitle {\n  display: inline-block;\n  height: 14px;\n  width: 14px;\n  background-image: url('/assets/icon_info.png');\n  background-repeat: no-repeat;\n  cursor: help;\n}\n\ntd {\n  padding: 10px;\n}\n\nh1 {\n  font-size: 130%;\n  margin: 1ex;\n}\n\ntd.rejected {\n  background-color: #FFE1D9;\n  border-left: 2px solid #fff;\n  border-radius: 0 4px 4px 0;\n}\n\ntd.accepted {\n  background-color: #E0F1DE;\n  border-radius: 0 0 0 4px;\n}\n\ntd.notRated {\n  min-width: 220px;\n  background-color: #EDEDED;\n  border-bottom: 2px solid #fff;\n  border-radius: 4px 0 0 0;\n}\n\ndiv.notRated {\n  font-size:130%;\n  font-weight: bold;\n  padding:3ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/rating-box/rating-box.component.css
// module id = ../../../../../src/app/rating-box/rating-box.component.css
// module chunks = main